import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import { createSystemCanvasControlType } from '../../Pages/Library/CustomModule/Store/CustomModule.action';
import { toasterMsg } from '../Toaster/Toaster';
import type { LibraryTitleInputProps } from './library-title-input.types';

type LibraryControlType = LibraryTitleInputProps['controlType'];

type UserDetailsState = {
  UserDetails?: { userInfo?: { userId?: string } };
};

type CreateControlTypeResponse = {
  code?: number;
};

export default function useSaveToLibrary() {
  const { t } = useTranslation('custom-module-system-canvas');
  const dispatch = useDispatch();
  const userId = useSelector((state: UserDetailsState) => state.UserDetails?.userInfo?.userId);

  return useCallback(
    async (title: string, controlType: LibraryControlType, contentData: unknown): Promise<boolean> => {
      const trimmedTitle = title.trim();
      if (!trimmedTitle) {
        toasterMsg(t('SYSTEM_CANVAS.SECTION_LIBRARY_TITLE_REQUIRED'), 'danger');
        return false;
      }
      if (!contentData) {
        toasterMsg(t('SYSTEM_CANVAS.CONTENT_DATA_REQUIRED'), 'danger');
        return false;
      }
      try {
        const response = (await dispatch(
          createSystemCanvasControlType(
            {
              title: trimmedTitle,
              content: { type: controlType, content: contentData },
              createdBy: userId,
              updatedBy: userId,
            },
            t,
          ),
        )) as CreateControlTypeResponse | undefined;
        return response?.code === SUCCESS_CODE;
      } catch {
        return false;
      }
    },
    [dispatch, t, userId],
  );
}

const SUCCESS_CODE = 200;
